import React from 'react';
import { logger } from '../logging.service';
import { ErrorCode } from './error-codes';

interface Props {
  name: string;
  errorCode: ErrorCode;
  children: React.ReactNode;
}

export class AppErrorBoundary extends React.Component<Props, { hasError: boolean }> {
  public static getDerivedStateFromError() {
    return { hasError: true };
  }
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    logger.error(
      this.props.errorCode,
      `${this.props.name} Error boundary: ${info.componentStack} | Message: ${error.message}`
    );
  }

  public render() {
    if (this.state.hasError) {
      return null;
    }
    return <>{this.props.children}</>;
  }
}
